// extracted by mini-css-extract-plugin
export default {"get_it_now_v2":"Ui","place_order_copy":"Vi","next_order_copy":"Wi","title_wrapper":"Xi","get_it_now_row":"Yi","get_it_now_remaining_items":"Zi","get_it_now_remaining_items_mob":"aj","order_summary":"bj","additional_items":"cj","account_content_slider":"ej","ingredient_carousel":"fj","ingredient_carouselwrapper":"gj","account_content_slide":"hj","account_subscription_section_mob":"ij","carouselwrapper":"jj"};
    if(module.hot) {
      // 1714442365910
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  